import React, { Component } from 'react';

import { ValidatorUtils } from '../utils';
import { Input, Button, Errors, Header } from '../components';
import { History as history, Routes as routes } from '../navigation';
import '../css/SignIn.css';

class PracticeCreateNew extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderCreatePracticeSection = () => {
    return <div className='standard-container'>
      <Header title='Add a new Practice to TeleTails' icon='fas fa-plus-circle' />
      <div className='flex-container-column' style={{ padding: 15 }}>
        <span style={{ fontSize: 14, color: 'grey', marginBottom: 15 }}>Add a new practice to TeleTails and start adding team members and clients to start consultations with.</span>
        <Button value='Add A New Practice'
                style={{ alignSelf: 'center', width: 200, paddingTop: 10, paddingBottom: 10, textAlign: 'center' }}
                onClick={ () => {
                  history.push(routes.PRACTICE_PLANS);
                }}/>
      </div>
    </div>
  }

  render() {
    return this.renderCreatePracticeSection();
  }

}


export default PracticeCreateNew
